import Component from '_core_ext/components/Component';

export default class GenerateBarcode extends Component {
    static get selector() {
        return '.js-generatebarcode';
    }

    init(...args) {
        super.init(args);

        this.$barcodeElements = this.$el.find('.barcode');

        this.renderBarcodes();
    }

    toSetC(text) {
        return text
            .match(/\d{2}/g)
            .map((ascii) => {
                var codeC = Number(ascii);
                var charCode = codeC > 94 ? codeC + 100 : codeC + 32;
                return String.fromCharCode(charCode);
            })
            .join('');
    }

    checkSum128(data, startCode) {
        var sum = startCode;
        for (var i = 0; i < data.length; i++) {
            var code = data.charCodeAt(i);
            var value = code > 199 ? code - 100 : code - 32;
            sum += (i + 1) * value;
        }

        var checksum = (sum % 103) + 32;
        if (checksum > 126) {
            checksum = checksum + 68;
        }
        return String.fromCharCode(checksum);
    }

    encodeToCode128(text, codeABC = 'B') {
        text = String(text);

        var startCode = String.fromCharCode(codeABC.toUpperCase().charCodeAt() + 138);
        var stop = String.fromCharCode(206);

        text = (codeABC === 'C' && this.toSetC(text)) || text;

        var check = this.checkSum128(text, startCode.charCodeAt(0) - 100);

        text = text.replace(/ /g, String.fromCharCode(194));

        return startCode + text + check + stop;
    }

    renderBarcodes() {
        this.$barcodeElements.each((index, element) => {
            var $element = $(element);
            var code = $element.data('barcode');

            if (!code) {
                return;
            }

            var set = $element.data('set');
            var encodedBarcode = this.encodeToCode128(code, set);

            $element.html(encodedBarcode);
        });
    }
}

module.exports = GenerateBarcode;
